enum TrackingSources {
  PD = 'pdp_rate_btn',
  REVIEW = 'pdp_writeReview_btn',
  VISUAL_FILTERS = 'visual_filter_selected',
}

export const mixpanelEventsForApp = {
  searchListingLoads: 'search_listing_loads',
  guide_clicked: 'guide_clicked',
  sort_applied: 'sort_applied',
  filter_applied: 'filter_applied',
  gpt_chat_ask_more_btn: 'gpt_chat_ask_more_btn',
  gpt_chat_invoked: 'gpt_chat_invoked',
  inline_filter_clicked: 'inline_filter_clicked',
  preview_clicked: 'preview_clicked',
  tiptile_clicked: 'tiptile_clicked',
  filter_clicked: 'filter_clicked',
  notify_me_clicked: 'notify_me_clicked',
};

export default TrackingSources;
